export default __webpack_public_path__ + "static/media/workoutfilters.bc5e6914.png";